import { MessageBox } from '@s4l/ds'
import { useS4LContext } from '@s4l/react-context'
import React from 'react'

const ResultsControlModule = () => {
  const { i18n } = useS4LContext()

  return (
    <MessageBox kind="info">
      <MessageBox.Title variant="body">
        {i18n.formatMessage({ id: 'results-control-module.messagebox-title' })}
      </MessageBox.Title>
      <MessageBox.Body variant="body">
        {i18n.formatMessage({ id: 'results-control-module.messagebox-body' })}
      </MessageBox.Body>
    </MessageBox>
  )
}

ResultsControlModule.displayName = 'ResultsControlModule'
export default ResultsControlModule
